import { Search } from 'components/search'
import { useRouter } from 'next/router'
import type { FC } from 'react'
import { ROUTE_PRODUCT_INDEX } from 'routes/products'
import { parseCookies } from 'nookies'
import type { SearchInputProps } from '.'
import {useMercadinho} from "hooks/use-mercadinho";

const SearchInput: FC<SearchInputProps> = () => {
  const router = useRouter()
  const cookies = parseCookies()
  const storedZipcode = (cookies.zipcode as never) || ''
  const { isMercadinho, mercadinhoID } = useMercadinho()

  function onSubmit(search: string) {
    if (router.pathname === '/pedido-facil') {
      router.push({ pathname: '/pedido-facil', query: search ? { search } : {} }, undefined, { shallow: true })
      return
    }
    // @ts-ignore
    if (!isMercadinho) {
      router.push({ pathname: ROUTE_PRODUCT_INDEX, query: { search, zipcode: storedZipcode } })
    } else {
      router.push({ pathname: `/mercadinho/${mercadinhoID}`, query: { search } })
    }
  }

  return <Search onSubmit={onSubmit} />
}

export default SearchInput
